import { Column } from 'devextreme-react/data-grid'
import React from 'react'
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid'
import useFormatMessage from '../../../utils/useFormatMessage'

const SevkiyatHareketleri = ({ groupage_data }) => {
    const { t } = useFormatMessage()

    return (
        <DatagridCustom
            dataSource={groupage_data?.data}
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}
            columnAutoWidth={true}
        >
            <Column
                caption={t("Grupaj No")}
                dataField="groupage_no"
                width={130}
            />
            <Column
                caption={t("Rota")}
                dataField="route"
                width={"auto"}
            />
            <Column
                caption={t("Grupaj Tarih")}
                dataField="groupage_date"
                alignment="center"
                dataType='datetime'
                calculateDisplayValue={(data) => {
                    // grupaj no 2 haneden fazla ise göster
                    if (data?.groupage_no?.length > 5) {
                        return data.groupage_date
                    }
                }}
            />
            <Column
                caption={t("Kapı Çıkış Tarih")}
                dataField="door_exit_date"
                alignment="center"
                width={"auto"}
            />
            <Column
                caption={t("Taşıyıcı")}
                dataField="contractor"
            />
            <Column
                caption={t("Tır Plaka")}
                dataField="truck_plate"
                alignment="center"
            />
            <Column
                caption={t("Şoför")}
                dataField="driver"
            />
            <Column
                caption={t("Grupaj Statü")}
                dataField="groupage_status"
            />
            <Column
                caption={t("Nereden")}
                dataField="from"
            />
            <Column
                caption={t("Nereye")}
                dataField="to"
            />
            <Column
                caption={t("Fatura Tarihi")}
                dataField="invoice_date"
                alignment="center"
                width={"auto"}
            />
        </DatagridCustom>
    )
}

export default SevkiyatHareketleri